import app from 'srcJs/App';
import React, { FC, PropsWithChildren, useMemo } from 'react';
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook';
import { useSelector } from 'react-redux';
import { State } from 'moduleBase/types/State';
import { InitResponse } from 'moduleBase/actions/types/InitResponseType';
import { REDUCER_GLOBAL_NAME } from 'moduleBase/constants';
import { GOOGLE_TAG_MANAGER_ID } from 'src/constants';

const GoogleTagManagerProvider: FC<PropsWithChildren<any>> = ({
  children,
}) => {
  if (!app.getExternalApp().isEnableGoogleTagManager()) {
    return children;
  }
  const dataLayer = useSelector<State, InitResponse['dataLayer']>(
    (state) => state[REDUCER_GLOBAL_NAME].dataLayer,
  );

  const gtmParams = useMemo<object>(() => ({
    id: GOOGLE_TAG_MANAGER_ID,
    dataLayer,
  }), []);

  return (
    <GTMProvider state={gtmParams}>
      {children}
    </GTMProvider>
  );
};

export { GoogleTagManagerProvider };
